<template>
  <div class="home">
    <div class="sub-header">
      <div class="left-img">
        <img src="@/assets/img/zuo@2x.png"
             alt />
      </div>
      <div class="phone side-bar-trigger"
           @click="drawer = true">
        <img src="@/assets/img/list.png"
             alt />
      </div>
      <div class="right-img">
        <img src="@/assets/img/you@2x.png"
             alt />
      </div>
    </div>
    <!--children-->
    <transition name="fadeInUp">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {}
  },
  name: 'Home',
  mounted () {
    this.pageLoadEvent()
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  methods: {
    pageLoadEvent () {
      if (this.isLogin === '' || this.$route.params.target === 'click') return
      let source = ''
      const query = this.$route.query
      if (query.utm_source === 'share') {
        source = '分享'
      } else if (query.utm_source === 'class') {
        source = '我的班级'
      } else if (query.utm_source === 'nav') {
        source = '导航'
      } else {
        source = '其他'
      }
      this.zhuGeEventTrack(this.zhugeEvents.HOME_PAGE.PAGE_LOADING, [source, this.isLogin ? '是' : '否'])
    }
  },
  watch: {
    isLogin () {
      this.pageLoadEvent()
    }
  }
}
</script>
